<template>
  <div class="caseDetails maxWidth">
    <div class="caseDetails-banner">
      <img :src="bannerlist.banner" alt="" />
    </div>
    <div class="caseDetails-main">
      <!-- 客户案例 -->
      <div class="caseDetails-mainTop">
        <div class="caseDetails-mainTopLeft">
          <span class="el-icon-sort-up"></span
          ><span @click="backClick">{{ bannerlist.type_name }}</span>
        </div>
        <div class="caseDetails-mainTopMain"></div>
        <div class="caseDetails-mainTopRight">
          <span>日期：{{ bannerlist.datetime }}</span>
        </div>
      </div>
      <div class="caseDetails-mainBox">
        <div class="caseDetails-mainBoxTop">
          <div class="heng"></div>
          <div class="">
            <span>{{ contentList.name }}</span>
            <img src="../../assets/bigTy.png" alt="" />
          </div>
        </div>
        <div class="caseDetails-mainBoxBanner">
          <div
            class="caseDetails-mainBoxText"
            v-html="contentList.content"
          ></div>
        </div>
      </div>
      <!-- 其他案例 -->
      <div class="caseDetails-other">
        <div class="caseDetails-otherTop">
          <div class="heng"></div>
          <div class="">
            <span>其他案例</span>
            <img src="../../assets/bigTy.png" alt="" />
          </div>
        </div>
        <div class="caseDetails-otherMain">
          <div
            class="mianContentBox"
            v-for="(item, index) in customerCaseList.lists"
            :key="index"
            @click="caseClick(item)"
          >
            <div class="mianContentBox-top">
              <img :src="item.bg" alt="" />
              <div class="mianContentBox-topTitle"></div>
              <div class="mianContentBox-topTitleBox">
                <div class="picBox"><img :src="item.pic" alt="" /></div>
                <span>{{ item.description }}</span>
              </div>
            </div>
            <div class="mianContentBox-bottom">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 开发流程 -->
    <div class="caseDetails-lc">
      <div class="caseDetails-lcTop">
        <div class="heng"></div>
        <span>开发流程</span>
      </div>
      <div class="caseDetails-lcMain">
        <div
          class="liuchengBox"
          v-for="(item, index) in liuchengList.lists"
          :key="index"
        >
          <div class="liuchengBox-number">
            <span>{{ index + 1 }}</span>
          </div>
          <div class="liuchengBox-item">
            <div class="liuchengBox-itemTop">
              <span>{{ item.name }}</span>
              <img src="../../assets/jiantou.png" alt="" />
            </div>
            <p>{{ item.description }}</p>
            <span @click="clickParent">立即咨询 ></span>
          </div>
        </div>
      </div>
    </div>
    <ZXDialog ref="mychild" />
  </div>
</template>

<script>
import ZXDialog from "../../components/ZXDialog.vue";

export default {
  name: "caseDetails",
  components: { ZXDialog },

  data() {
    return {
      customerCaseList: {},
      liuchengList: {},
      bannerlist: {},
      date: "",
      contentList: {},
      id: ""
    };
  },
  created() {
    this.id = this.$route.query.id;
    // console.log(this.id);
    this.getItemList();
  },
  methods: {
    clickParent() {
      this.$refs.mychild.parentHandleclick();
    },
    getItemList() {
      this.$axios
        .get("index/common/getCaseContent", {
          params: {
            id: this.id
          }
        })
        .then(res => {
          // console.log(res);
          if (res.status == 200) {
            this.bannerlist = res.data.data["01"];
            this.contentList = res.data.data["02"];
            this.customerCaseList = res.data.data["03"];
            this.liuchengList = res.data.data["04"];
          }
        });
    },
    caseClick(item) {
      // console.log(item.id);
      if (item.id != this.id) {
        this.id = item.id;
        this.getItemList();
        this.$router.push({ name: "caseDetails", query: { id: item.id } });
        document.documentElement.scrollTop = 0;
      }
      document.documentElement.scrollTop = 0;

      // location.reload();
    },
    backClick() {
      this.$router.push({
        name: "customerCase"
      });
    }
  }
};
</script>

<style scoped>
.maxWidth {
  max-width: 100%;
}
.caseDetails {
  width: 1920px;
  margin-top: 70px;
  margin: 0 auto;
}
.caseDetails-banner img {
  width: 100%;
  display: block;
  height: 610px;
}
/* 客户案例 */
.caseDetails-main {
  width: 1380px;
  margin: 0 auto;
  position: relative;
  top: -165px;
}
.caseDetails-main .caseDetails-mainTop {
  padding: 0 50px;
}
.caseDetails-mainTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 36px;
}
.caseDetails-mainTopMain {
  width: 920px;
  height: 1px;
  border: 1px solid rgba(204, 204, 204, 0.6);
}
.caseDetails-mainTopLeft span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}
.caseDetails-mainTopLeft .el-icon-sort-up {
  transform: rotate(-90deg);
  margin-right: 20px;
}
.caseDetails-mainTopRight span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.caseDetails-mainBox {
  width: 1380px;
  background: #fffdff;
  border: 1px solid #ffffff;
  box-shadow: 0px -6px 30px 0px rgba(0, 0, 0, 0.12);
  border-radius: 0px 20px 0px 0px;
  padding: 50px 50px 60px 50px;
  margin-bottom: 84px;
}
.caseDetails-mainBoxTop {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 49px;
}
.caseDetails-mainBoxTop .heng {
  width: 70px;
  height: 3px;
  background: #df3a3a;
  margin-bottom: 17px;
}
.caseDetails-mainBoxTop > div span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.caseDetails-mainBoxTop > div img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: 7px;
  left: 110px;
  transform: rotate(-270deg);
}
.caseDetails-mainBoxText >>> img {
  display: block;
  width: 1280px;
  margin-bottom: 59px;
}
.caseDetails-mainBoxText >>> p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  line-height: 30px;
  text-indent: 30px;
}
/* 其他案例 */
.caseDetails-other {
  padding: 0 50px;
  /* margin-bottom: 96px; */
}
.caseDetails-otherTop {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 65px;
}
.caseDetails-otherTop .heng {
  width: 70px;
  height: 3px;
  background: #df3a3a;
  margin-bottom: 17px;
}
.caseDetails-otherTop > div span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.caseDetails-otherTop > div img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: 7px;
  left: 110px;
  transform: rotate(-270deg);
}
.caseDetails-otherMain {
  display: flex;
  flex-wrap: wrap;
}
.caseDetails-otherMain .mianContentBox {
  width: 410px;
  height: 366px;
  background: #ffffff;
  box-shadow: 0px 4px 30px 0px rgba(89, 98, 107, 0.12);
  margin-right: 25px;
  margin-bottom: 25px;
  padding: 8px;
  cursor: pointer;
}
.caseDetails-otherMain .mianContentBox:nth-child(3n) {
  margin-right: 0;
}
.mianContentBox-top {
  position: relative;
}
.mianContentBox-top > img {
  display: block;
  width: 100%;
}
.mianContentBox-topTitle {
  width: 394px;
  height: 36px;
  background-color: rgba(13, 13, 14, 0.6);
  opacity: 0.6;
  position: absolute;
  bottom: 0;
}
.mianContentBox-topTitleBox {
  position: absolute;
  bottom: -27px;
  display: flex;
  left: 27px;
  line-height: 60px;
}
.mianContentBox-topTitleBox .picBox {
  width: 75px;
  height: 76px;
  border-radius: 50%;
  margin-right: 20px;
  border: 1px solid #ffffff;
  overflow: hidden;
}
.mianContentBox-topTitleBox img {
  display: block;
  /* border: 1px solid #ffffff; */
  /* box-shadow: 0px 2px 10px 0px rgba(76, 76, 76, 0.1);
  border-radius: 50%; */
}
.mianContentBox-topTitleBox span {
  width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.mianContentBox-bottom {
  padding-left: 27px;
  padding-top: 56px;
}
.mianContentBox-bottom span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #2a2b33;
}
/* 流程开发 */
.caseDetails-lc {
  height: 558px;
  background-image: url("~../../assets/bannerLC.png");
  background-repeat: no-repeat;
  background-size: 100%;
  position: relative;
  padding-top: 84px;
}
.caseDetails-lcTop {
  display: flex;
  flex-direction: column;
  padding-left: 320px;
  padding-bottom: 74px;
  border-bottom: 1px solid rgba(214, 219, 221, 0.6);
}
.caseDetails-lcTop .heng {
  width: 70px;
  height: 3px;
  background: #ffffff;
  margin-bottom: 17px;
}
.caseDetails-lcTop span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.caseDetails-lcMain {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  top: -13px;
}
.liuchengBox {
  margin-right: 20px;
}
.liuchengBox:last-child {
  margin-right: 0;
}
.liuchengBox .liuchengBox-number {
  width: 26px;
  height: 26px;
  background: #ffffff;
  border: 6px solid rgba(255, 66, 66, 0.1);
  border-radius: 50%;
  text-align: center;
  line-height: 14px;
  margin-bottom: 32px;
}
.liuchengBox .liuchengBox-number span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ff4242;
}
.liuchengBox-item {
  width: 240px;
  height: 166px;
  background: #ffffff;
  box-shadow: 0px 14px 10px 0px rgba(0, 0, 0, 0.16);
  padding: 29px 20px 21px;
}
.liuchengBox-item > p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
  margin-bottom: 20px;
}
.liuchengBox-item > span {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #595959;
  line-height: 10px;

  background: linear-gradient(0deg, #dc3939 0%, #ff4242 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  cursor: pointer;
}
.liuchengBox-itemTop {
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
}
.liucphengBox-itemTop span {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
}
.liuchengBox-itemTop img {
  display: block;
  width: 25px;
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/Case/CaseDetails.vue